import Item, {ItemProps as _ItemProps} from "./Item";

export default Item;

export type ItemProps = _ItemProps;
